import { render, staticRenderFns } from "./ProfitReportTransactionsHead.vue?vue&type=template&id=37c92267&scoped=true"
import script from "./ProfitReportTransactionsHead.vue?vue&type=script&lang=js"
export * from "./ProfitReportTransactionsHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c92267",
  null
  
)

export default component.exports